import { gtag } from "@/index";
import { useLoras } from "@features/loras/use-loras";
import { useUser } from "@features/user/use-user";
import { useEffectPlease, useNavigateAlt } from "@features/utils";
import posthog from "posthog-js";
import { useParams } from "react-router-dom";

let originalSearch = window.location.search; // Store original search parameters before any navigation

export const useRedirectStripe = () => {
  const navigate = useNavigateAlt();
  const { user } = useUser();
  const { site } = useParams();
  const { loras } = useLoras();

  const canCreateSelfModel =
    (user.data?.credits || 0) + (user.data?.additional_credits || 0) >= 400;

  // New onboarding data
  // We don't need to track these in state since we store them in localStorage and analytics

  // Mark that the welcome flow has been completed
  const completeWelcome = () => {
    localStorage.setItem("did_welcome", "true");
  };

  // Check for stripe=1 in query parameters
  useEffectPlease(() => {
    const urlParams = new URLSearchParams(
      originalSearch || window.location.search
    );
    if (urlParams.get("stripe") === "1" && canCreateSelfModel) {
      console.log("Redirecting after Stripe checkout");
      originalSearch = ""; // Clear original search to avoid repeated redirects
      gtag({
        event: "stripe_checkout",
        plan: user.data?.plan,
      });
      posthog.capture("stripe_checkout", {
        plan: user.data?.plan,
      });

      // Directly open create model flow
      completeWelcome();
      const upgradableLoraId = (loras.data || []).find(
        (l) => l.technology === "images" && l.subtype === "avatar"
      );
      if (upgradableLoraId) {
        navigate(`/${site || "portraits"}/lora/${upgradableLoraId}/upgrade`, {
          state: { userName: user.data?.name, fromWelcome: true },
        });
      } else {
        navigate(`/${site || "portraits"}/lora/model`, {});
      }
    }
  }, [canCreateSelfModel, user.data?.name, loras.data?.length]);
};
